/**
 * The sign-in refusals that are the ANSWER, not a fault (kz2 M12 N-8): a suspended account
 * (`auth/user-disabled`), a wrong phone or password, too many tries. The login page says them to the
 * person; they are never reported to the error tracker (rollbar) as errors — only logged at warn.
 * Anything else (the network, a profile read that failed, a bug) still is.
 */
export const EXPECTED_SIGN_IN_REFUSALS: readonly string[] = [
  'auth/user-disabled',
  'auth/wrong-password',
  'auth/invalid-credential',
  'auth/invalid-login-credentials',
  'auth/user-not-found',
  'auth/invalid-email',
  'auth/missing-password',
  'auth/too-many-requests',
];

/** The Firebase Auth (or mock gateway) code of a sign-in rejection, if it carries one. */
export function signInErrorCode(error: unknown): string | null {
  const code = (error as { code?: unknown } | null | undefined)?.code;
  return typeof code === 'string' ? code : null;
}

/** Is this rejection one of the expected refusals (see `EXPECTED_SIGN_IN_REFUSALS`)? */
export function isExpectedSignInRefusal(error: unknown): boolean {
  const code = signInErrorCode(error);
  return !!code && EXPECTED_SIGN_IN_REFUSALS.includes(code);
}
